import { Box, Grid } from '@methanesat/ui-components';
import { ReactNode } from 'react';
import { DrawerDivider } from './DrawerDivider';
import { MapControlAccordion } from '../../../MapControls';
import { DrawerCard } from '../DrawerWithCards/DrawerCard';
import { MapControlAccordionProps } from '../../../../types';

/**
 * Component that renders a DrawerCard with Header, Body & Footer for
 * DrawerWithCards. If accordion = true, renders Header in the accordion
 * summary & Body & Footer in the accordion contents.
 * Currently used for OGI cards only.
 */
export const DrawerCardContainer = ({
    HeaderItems,
    Body,
    Footer,
    accordion,
    AccordionProps,
    expanded
}: {
    HeaderItems?: ReactNode;
    Body?: ReactNode;
    Footer?: ReactNode;
    accordion?: boolean;
    AccordionProps?: MapControlAccordionProps;
    expanded?: boolean;
}) => {
    const Header = (
        <Grid container justifyContent="space-between" flexDirection="column">
            {HeaderItems}
        </Grid>
    );

    const FooterWithDivider = (
        <>
            {Footer && (
                <>
                    <DrawerDivider />
                    {Footer}
                </>
            )}
        </>
    );
    const BodyWithDivider = (
        <>
            {Body && (
                <>
                    <DrawerDivider />
                    {Body}
                </>
            )}
        </>
    );
    return (
        <DrawerCard
            data-active={''}
            data-testid="drawer-card"
            elevation={0}
            sx={{
                '&:not(:last-child)': {
                    marginBottom: 3
                }
            }}
        >
            {accordion ? (
                <MapControlAccordion HeaderContents={<Box>{Header}</Box>} {...AccordionProps} expanded={expanded}>
                    {BodyWithDivider}
                    {FooterWithDivider}
                </MapControlAccordion>
            ) : (
                <>
                    {Header}
                    {BodyWithDivider}
                    {FooterWithDivider}
                </>
            )}
        </DrawerCard>
    );
};
